/* eslint-disable */

import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EmailIcon from '@mui/icons-material/Email';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EnhancedEncryptionIcon from '@mui/icons-material/EnhancedEncryption';
import api from '../../utils/functions/api';
import { getStorage } from '../../utils/functions/localstorage';

const FinalConfirmationPopup = ({ open, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: {
        borderRadius: '15px',
        width: '400px',
      },
    }}
  >
    <DialogContent>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 'bold',
          fontSize: '24px',
          marginTop: '20px',
        }}
      >
        <CheckCircleOutlineIcon
          sx={{ fontSize: 90, color: 'green', marginBottom: '10px' }}
        />
        บันทึกสำเร็จ !
      </Box>
    </DialogContent>
    <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box
        sx={{
          width: '25%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: '1px solid',
          borderRadius: '9px',
          color: '#45A6F5',
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: '#E3F3FF',
          },
          margin: 'auto',
        }}
      >
        <Button onClick={onClose}>Close</Button>
      </Box>
    </DialogActions>
  </Dialog>
);

const EditAccountManagementAdmin = ({ open, onClose, data }) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [account, setAccount] = useState({
    email: '',
    mkeys: [{ mkey: '' }],
  });
  const [originalAccount, setOriginalAccount] = useState({
    email: '',
    mkeys: [{ mkey: '' }],
  });
  const [errors, setErrors] = useState({ email: '', mKeys: [] });

  useEffect(() => {
    if (data) {
      const initialAccount = {
        email: data.email || '',
        mkeys: data.Company
          ? data.Company.map((c) => ({ mkey: c.mkey }))
          : [{ mkey: '' }],
      };
      setAccount(initialAccount);
      setOriginalAccount(initialAccount); // Store original data
    }
  }, [data]);

  const validateFields = () => {
    let formHasErrors = false;
    const newErrors = { email: '', mKeys: [] };

    if (!account.email) {
      formHasErrors = true;
      newErrors.email = 'กรุณากรอกอีเมลล์';
    }

    if (
      account.mkeys.length === 0 ||
      account.mkeys.every((mKey) => mKey.mkey.trim() === '')
    ) {
      formHasErrors = true;
      newErrors.mKeys[0] = 'ต้องมีขั้นต่ำ 1 MKey';
    }

    account.mkeys.forEach((mKey, index) => {
      if (!mKey.mkey.trim()) {
        formHasErrors = true;
        newErrors.mKeys[index] = 'กรุณากรอก MKey';
      }
    });

    setErrors(newErrors);
    return !formHasErrors;
  };

  const handleEdit = async () => {
    if (!validateFields()) return;

    try {
      let mkeyArray = account.mkeys.map((mkeyObj) => mkeyObj.mkey);

      let { data: response } = await api.post(
        `${process.env.REACT_APP_APIHOST}/edit_user`,
        {
          id: data.id,
          email: account.email,
          mkey: mkeyArray, // Send mkey as an array
        },
        {
          headers: { Authorization: getStorage('token') },
        },
      );

      if (response === 'edit success') {
        setShowConfirmation(true);
      }
    } catch (error) {
      console.error('Failed to edit user:', error);
      alert('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
    } finally {
      setShowConfirmation(true);
    }
  };

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
    window.location.reload();
  };

  const handleClose = () => {
    setAccount(originalAccount); // Reset to original data
    onClose();
  };

  const addMKey = () => {
    setAccount((prev) => ({
      ...prev,
      mkeys: [...prev.mkeys, { mkey: '' }],
    }));
  };

  const removeMKey = (index) => {
    if (account.mkeys.length === 1) {
      alert('ต้องมีอย่างน้อย 1 MKey');
      return;
    }

    setAccount((prev) => ({
      ...prev,
      mkeys: prev.mkeys.filter((_, i) => i !== index),
    }));
  };

  const handleMKeyChange = (index, value) => {
    setAccount((prev) => {
      const newMKeys = [...prev.mkeys];
      newMKeys[index] = { ...newMKeys[index], mkey: value };
      return { ...prev, mkeys: newMKeys };
    });
  };

  const handleAccountChange = (event) => {
    const { name, value } = event.target;
    setAccount((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose} // Use handleClose to reset
        PaperProps={{
          sx: {
            borderRadius: '15px',
            width: '100%',
            maxWidth: '550px',
          },
        }}
      >
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginRight: '10px',
              marginLeft: '10px',
              marginTop: '6px',
            }}
          >
            <span>แก้ไขบัญชี</span>
            <Button
              sx={{
                width: '110px',
                border: '1px solid ',
                color: '#0F4898',
                backgroundColor: 'transparent',
                '&:hover': {
                  backgroundColor: 'rgba(81, 210, 69, 0.1)',
                },
              }}
              onClick={addMKey}
            >
              <AddIcon sx={{ marginRight: '5px' }} /> เพิ่ม MKey
            </Button>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              marginRight: '10px',
              marginLeft: '10px',
              marginTop: '6px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '16px',
              }}
            >
              <EmailIcon sx={{ marginRight: '20px' }} />
              <TextField
                label="อีเมลล์"
                variant="outlined"
                size="small"
                name="email"
                value={account.email}
                onChange={handleAccountChange}
                sx={{ width: '380px' }}
                error={!!errors.email}
                helperText={errors.email}
              />
            </Box>
            {account.mkeys.map((mKey, index) => (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '16px',
                }}
              >
                <EnhancedEncryptionIcon sx={{ marginRight: '20px' }} />
                <TextField
                  label="MKey"
                  variant="outlined"
                  size="small"
                  value={mKey.mkey}
                  onChange={(e) => handleMKeyChange(index, e.target.value)}
                  sx={{ width: '380px' }}
                  error={!!errors.mKeys[index]}
                  helperText={errors.mKeys[index]}
                />
                <IconButton
                  sx={{
                    color: '#FC3A3A',
                    marginLeft: '20px',
                  }}
                  onClick={() => removeMKey(index)}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            ))}
          </Box>
        </DialogContent>
        <DialogActions sx={{ marginBottom: '20px', marginRight: '20px' }}>
          <Button
            onClick={handleClose}
            sx={{
              width: '100px',
              border: '1px solid',
              color: '#FC3A3A',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(252, 58, 58, 0.1)',
              },
            }}
          >
            ยกเลิก
          </Button>
          <Button
            onClick={handleEdit}
            sx={{
              width: '100px',
              border: '1px solid ',
              color: '#51D245',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(81, 210, 69, 0.1)',
              },
            }}
          >
            บันทึก
          </Button>
        </DialogActions>
      </Dialog>

      <FinalConfirmationPopup
        open={showConfirmation}
        onClose={handleCloseConfirmation}
      />
    </>
  );
};

export default EditAccountManagementAdmin;
